import React from 'react';
import {Flex, Tag} from "antd";
import style from "./ProductDetail.module.scss";
import {BiDislike, BiLike} from "react-icons/bi";
import {StyledCategoryTag, StyledDivider} from "./ProductDetail.styled";
import {ProductTitleProps} from "../../models";
import { IoStar } from 'react-icons/io5';
import {useNavigate} from "react-router-dom";

const ProductTitle = ({product}:ProductTitleProps) => {
    const navigate = useNavigate();
    return (
        <Flex vertical className={'mt-1'}>
            <Flex align={"start"} justify={"space-between"}>
                <span className={style.productTitle}>{product?.name}</span>
                 {product?.ratingAverage !== null && <Flex gap={"small"} align={"center"}>
                    <span className={style.ratingCount}> <IoStar className={style.ratingIcons}/>{product?.ratingAverage}</span>
                    <span className={style.voterCount}>{`(امتیاز ${product?.ratingCount} خریدار)`}</span>
                </Flex>}
            </Flex>

            <Flex justify={"space-between"}>
            <span className={style.productStatus}>{product?.productStatus?.description}</span>

                <Flex align={"center"}>
                    <StyledCategoryTag onClick={() => navigate("/product-list/"+product?.category?.categoryId+"/"+product?.category?.subCategoryId ,
                        {state : {subCategoryTitle : product?.category?.subCategoryTitle}})}>
                        {product?.category?.subCategoryTitle}</StyledCategoryTag>
                </Flex>
            </Flex>
            <StyledDivider/>
        </Flex>
    );
};

export default ProductTitle;
